



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNISKILLSGETBYID= createAsyncThunk(
  "AlumniSkillsGetById/AlumniSkillsGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniSkillsGetByIdSlice = createSlice({
  name: "AlumniSkillsGetByIdSlice",
  initialState: {
    AlumniSkillsGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniSkillsGetById: (state) => {
        state.AlumniSkillsGetById.loading = false
        state.AlumniSkillsGetById.error = false
        state.AlumniSkillsGetById.data = []
        state.AlumniSkillsGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNISKILLSGETBYID.fulfilled, (state, action) => {
      state.AlumniSkillsGetById = {
        ...state.AlumniSkillsGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNISKILLSGETBYID.pending, (state, action) => {
      state.AlumniSkillsGetById = {
        ...state.AlumniSkillsGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNISKILLSGETBYID.rejected, (state, action) => {
      state.AlumniSkillsGetById = {
        ...state.AlumniSkillsGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniSkillsGetByIdAction = {
    ALUMNISKILLSGETBYID,
};

export { AlumniSkillsGetByIdAction };
export default AlumniSkillsGetByIdSlice.reducer;
export const {setInitialStateOfAlumniSkillsGetById} = AlumniSkillsGetByIdSlice.actions
